// extracted by mini-css-extract-plugin
export default {"body":"body-e1Rfj","inputContainer":"inputContainer-cop5Y","inputField":"inputField-sCDB7","clear":"clear-Beo3Q","counter":"counter-Hit3W"};